// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import styled from 'styled-components';
// import { SearchContext } from '../SearchContext'; // make sure path is correct

// const CategoriesDropDown = () => {
//   const [inputValue, setInputValue] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [categories, setCategories] = useState([]);

//   const { setSelectedCategory } = useContext(SearchContext);

//   const handleSelect = (value) => {
//     setSelectedCategory(value);
//     setInputValue(value);
//     setShowDropdown(false);
//   };

//   useEffect(() => {
//     axios
//       .get('https://api.bakpoket.com/api/AToZ/available-categories')
//       .then((res) => {
//         const allOption = ['All',...res.data]; // ✅ Add "All"
//         setCategories(allOption);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(()=>{
    
//   })

//   return (
//     <Wrapper>
//       <div className="selectors">
//         <input
//           type="search"
//           placeholder="Select or type category"
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           onFocus={() => setShowDropdown(true)}
//           onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
//         />
//         {showDropdown && (
//           <ul className="dropdown">
//             {categories
//               .filter(
//                 (category) =>
//                   typeof category === 'string' &&
//                   category.toLowerCase().includes(inputValue.toLowerCase())
//               )
//               .map((category, i) => (
//                 <li key={i} onClick={() => handleSelect(category)}>
//                   {category}
//                 </li>
//               ))}
//           </ul>
//         )}
//       </div>
//     </Wrapper>
//   );
// };

// export default CategoriesDropDown;

// // your existing styled-component stays unchanged


// const Wrapper = styled.div`
//   .selectors {
//     position: relative;
//     width: 240px;

//     input {
//       padding: 4px 10px 4px 8px;
//       font-size: 12px;
//       border: 1px solid #ccc;
//       border-radius: 4px;
//       width: 100%;
//     }

//     .dropdown {
//       position: absolute;
//       top: 36px;
//       left: 0;
//       right: 0;
//       background: #fff;
//       border: 1px solid #ccc;
//       border-radius: 4px;
//       max-height: 150px;
//       overflow-y: auto;
//       list-style: none;
//       margin: 0;
//       padding: 0;
//       z-index: 10;

//       li {
//         padding: 8px;
//         cursor: pointer;
//         border-bottom: 1px solid #eee;

//         &:hover {
//           background-color: #f0f0f0;
//         }
//       }

//       .no-match {
//         color: #888;
//       }
//     }
//   }

//   @media (max-width: 768px) {
//     .selectors {
//       width: 100%;

//       input {
//         font-size: 12px;
//         padding: 6px 8px;
//       }
//     }
//   }
// `;


// import React, { useEffect, useState, useContext } from 'react';
// import axios from 'axios';
// import styled from 'styled-components';
// import { SearchContext } from '../SearchContext'; // make sure path is correct

// const CategoriesDropDown = () => {
//   const [inputValue, setInputValue] = useState('');
//   const [inputValueFinal, setInputValueFinal] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [categories, setCategories] = useState([]);

//   const { setSelectedCategory } = useContext(SearchContext);

//     const handleSelect = (value) => {
//       // setSelectedCategory(value);
//       setInputValue(value);
//       setShowDropdown(false);
//       // setInputValueFinal(value)
//     };

//     useEffect(()=>{

//       if (inputValue.trim() === '') {
//         console.log('inputValue','All')
//       }else{
//         console.log('inputValue',inputValueFinal)
//       }
//     },[inputValue])



//   // ✅ Load categories and include "All"
//   useEffect(() => {
//     axios
//       .get('https://api.bakpoket.com/api/AToZ/available-categories')
//       .then((res) => {
//         const allOption = [ ...res.data];
//         setCategories(allOption);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   return (
//     <Wrapper>
//       <div className="selectors">
//         <input
//           type="search"
//           placeholder="Select or type category"
//           value={inputValue}
//           onChange={(e) => {
//             const value = e.target.value;
//             setInputValue(value);

//             // ✅ If user clears input, set category to "All"
//             if (value.trim() === '') {
//               setSelectedCategory('All');
//             }
//           }}
//           onFocus={() => setShowDropdown(true)}
//           onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
//         />

//         {showDropdown && (
//           <ul className="dropdown">
//             {categories
//               .filter(
//                 (category) =>
//                   typeof category === 'string' &&
//                   category.toLowerCase().includes(inputValue.toLowerCase())
//               )
//               .map((category, i) => (
//                 <li key={i} onClick={() => handleSelect(category)}>
//                   {category}
//                 </li>
//               ))}
//           </ul>
//         )}
//       </div>
//     </Wrapper>
//   );
// };

// export default CategoriesDropDown;

import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { SearchContext } from '../SearchContext';

const CategoriesDropDown = () => {
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [categories, setCategories] = useState([]);

  const { setSelectedCategory } = useContext(SearchContext);

  // ✅ SELECT from dropdown
  const handleSelect = (value) => {
    setInputValue(value);
    setSelectedCategory(value);
    // console.log('Selected:', value);
    setShowDropdown(false);
  };

  // ✅ Whenever inputValue changes, decide what to log
  useEffect(() => {
    if (inputValue.trim() === '') {
      // console.log('All');              // user cleared input
      setSelectedCategory('All');
    } else {
      console.log('Searching:', inputValue); // user typing
    }
  }, [inputValue]);

  // ✅ Fetch categories
  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/AToZ/available-categories')
      .then((res) => {
        setCategories(res.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Wrapper>
      <div className="selectors">
        <input
          type="search"
          placeholder="Select or type category"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
        />

        {showDropdown && (
          <ul className="dropdown">
            {categories
              .filter((category) =>
                typeof category === 'string'
                  ? category.toLowerCase().includes(inputValue.toLowerCase())
                  : false
              )
              .map((category, i) => (
                <li key={i} onClick={() => handleSelect(category)}>
                  {category}
                </li>
              ))}

            {/* ✅ Show "No results" if search yields nothing */}
            {categories.filter((cat) =>
              typeof cat === 'string'
                ? cat.toLowerCase().includes(inputValue.toLowerCase())
                : false
            ).length === 0 && <li className="no-match">No match found</li>}
          </ul>
        )}
      </div>
    </Wrapper>
  );
};

export default CategoriesDropDown;


const Wrapper = styled.div`
  .selectors {
    position: relative;
    width: 240px;

    input {
      padding: 4px 10px 4px 8px;
      font-size: 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      width: 100%;
    }

    .dropdown {
      position: absolute;
      top: 36px;
      left: 0;
      right: 0;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      max-height: 150px;
      overflow-y: auto;
      list-style: none;
      margin: 0;
      padding: 0;
      z-index: 1 !important;

      li {
        padding: 8px;
        cursor: pointer;
        border-bottom: 1px solid #eee;

        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .selectors {
      width: 100%;

      input {
        font-size: 12px;
        padding: 6px 8px;
      }
    }
  }
`;
